import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-progress-bar-overlay',
  standalone: false,

  templateUrl: './progress-bar-overlay.component.html',
  styleUrl: './progress-bar-overlay.component.scss',
})
export class ProgressBarOverlayComponent {
  @HostBinding('class.hidden')
  private _progressBar = true;

  public show(messaggio?: string) {
    setTimeout(() => {
      this._progressBar = false;
      if (messaggio) {
        this.templateMessage = messaggio;
      }
    }, 0);
  }

  public hide() {
    setTimeout(() => {
      this._progressBar = true;
      this.templateMessage = '';
    }, 0);
  }

  //non accessibile da @ViewChild
  protected templateMessage: string = '';
}
